module.exports = function () {
  var html = "\n      <div class=\"language-zone-overlay\" id=\"language-zone-overlay\">\n\t<div>\n          <div class=\"status\"></div>\n          <div class=\"controls\"></div>\n\t</div>\n\t<div class=\"debaters-container\">\n  \t  <div class=\"debaters\"></div>\n        </div>\n      </div>\n  ";
  return html;
};